<div class="container-fluid no-gutters container-box" [ngStyle]="{'background-image': getUrl(), 'background-size': 'cover',
'background-position': '50%', 'overflow': 'auto'}">
    <div class="border-box">
        <h5>
            <strong>
                Register
            </strong>
        </h5>
        Get secure access to GE tools and documentation.
        <div class="row pt-2 pl-3">
            <a (click)="goPageRegister()">
                <button type="button" class="btn btn-primary button mr-4">
                    Register
                    <i class="fa fa-arrow-right pl-2"></i>
                </button>
            </a>
        </div>
    </div>

    <div class="border-box">
        <h5>
            <strong>Sign In</strong>
        </h5>
        If you already have an account, please sign in.
        <div class="row pt-2 pl-3">
            <a href="/login"><button type="button" class="btn btn-primary button mr-4">Sign In<i class="fa fa-arrow-right pl-2"></i></button></a>
            <a href="https://nextgen.ge-registrar.com/b2bregistration/index.html#/forgotuserid" class="mt-2 font-size-link">Forgot User ID?</a>
            <div class="px-2 mt-2 font-size-link">/</div>
            <a href="https://nextgen.ge-registrar.com/b2bregistration/index.html#/forgotpassword" class="mt-2 font-size-link">Forgot Password?</a>

            <!-- <div class="px-2 mt-2 font-size-link">/</div>
            <a href="" class="mt-2 font-size-link">Need help?</a> -->

            <div class="px-2 mt-2 font-size-link">/</div>
            <a href="https://nextgen.ge-registrar.com/b2bregistration/index.html#/faqs" class="mt-2 font-size-link">FAQ?</a>
        </div>
    </div>
    <footer class="row col-12 is-fluid justify-content-center pb-4" style="position: fixed; bottom: 0;">
        <div class="col-4 justify-content-start align-items-left">
            <img class="img-filter" src="https://registration.gepower.com/assets/full-logo.svg" alt="">
        </div>
        <div class="row col-8 justify-content-end ">
            <!-- <div class="pr-4 d-none d-md-block">
                <a href="#/help" class="text-white">Need help? Contact us.</a>
            </div> -->
            <div class="pr-4 d-none d-md-block">
                <a href="https://www.gepower.com/privacy-policy" rel="noopener noreferrer" class="text-white"
                    target="_blank">
                    Privacy
                </a>
            </div>
            <div class="pr-4 d-none d-md-block">
                <a href="https://www.gepower.com/terms-conditions" rel="noopener noreferrer" class="text-white"
                    target="_blank">
                    Terms
                </a>
            </div>
            <div class="pr-4 d-none d-md-block">
                <a href="https://www.gepower.com/cookies.html" rel="noopener noreferrer" class="text-white"
                    target="_blank">
                    Cookies
                </a>
            </div>

            <div class="pr-4 d-none d-md-block">
                <a href="assets/user_guide_rev2018.pdf" target="_blank" rel="noopener noreferrer" class="text-white"
                    download="GESSORegistrationGuide.pdf">
                    Registration Guide
                </a>
            </div>
            <div class="d-none d-md-block">
                <a id="copyright" target="_blank" rel="noopener noreferrer" class="text-white"
                    href="https://www.ge.com">@ {{year}} General
                    Electric</a>
            </div>
        </div>
    </footer>
</div>